function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.433 5.825A3.983 3.983 0 0021 5H9a4 4 0 00-4 4v12a4 4 0 004 4h12a4 4 0 004-4v-8.257l-2 2V21a2 2 0 01-2 2H9a2 2 0 01-2-2V9a2 2 0 012-2h12c.362 0 .7.096.994.264l1.439-1.44z",
  fill: "currentColor"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.207 5.293a1 1 0 010 1.414l-12 12a1 1 0 01-1.414 0l-4.5-4.5a1 1 0 111.414-1.414l3.793 3.793L26.793 5.293a1 1 0 011.414 0z",
  fill: "currentColor"
});
function SvgCheckedBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref, _ref2);
}
export default __webpack_public_path__ + "fonts/checked-box-a7885c87f458b79ca66240c883489063.svg";
export { SvgCheckedBox as ReactComponent };